const config = {
  //basename: '/home',
  defaultPath: '/dashboard',
/*   fontFamily: 'Sarabun', sans-serif`, */
  fontFamily: `'Sarabun', sans-serif`,
  borderRadius: 16
};

export default config;
////////